import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";

import { Constants } from "../../shared/constants/constants";
import { DataRevisionIds } from "../../shared/constants/enums";
import { AdaaHelper, getPlanRevId, isDsV1, isDsV2, isDsV3 } from "../utils";

export function NotArchivedPlan(): CanActivateFn | CanActivateChildFn {
  return () => {
    const router = inject(Router);

    const planStatus =
      AdaaHelper.getLocalStorage(Constants.localStorageKeys.currentPlan, { type: "prop", property: "status" }) ?? 0;

    return planStatus !== Constants.OBJECT_STATUS.ARCHIVED && planStatus !== Constants.OBJECT_STATUS.CLOSED
      ? true
      : router.createUrlTree(["/403"]);
  };
}

export function DsV3Plan(): CanActivateFn | CanActivateChildFn {
  return () => {
    const router = inject(Router);

    return isDsV3() ? true : router.createUrlTree(["/403"]);
  };
}

export function DsV2Plan(): CanActivateFn | CanActivateChildFn {
  return () => {
    const router = inject(Router);

    return isDsV2() ? true : router.createUrlTree(["/403"]);
  };
}

export function DsV1Plan(): CanActivateFn | CanActivateChildFn {
  return () => {
    const router = inject(Router);

    return isDsV1() ? true : router.createUrlTree(["/403"]);
  };
}

export function checkByPlan(revIds: DataRevisionIds[]): CanActivateFn | CanActivateChildFn {
  return () => {
    const router = inject(Router);
    const revId = getPlanRevId();
    const pass = revIds.includes(revId);

    return pass ? true : router.createUrlTree(["/403"]);
  };
}
